// NavTab.jsx
import React, { useState } from "react";

import "./NavTab.css";

const NavTab = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div className="navtab">
      <ul className="nav nav-tabs btn-group border-0" role="group">
        {tabs.map((tab, index) => (
          <li
            key={index}
            className={`nav-item rounded-0 ${index === activeTab ? "active" : ""}`}
          >
            <span
              className="nav-link rounded-0"
              onClick={() => handleTabClick(index)}
              role="button"
            >
              {tab.label}
            </span>
          </li>
        ))}
      </ul>

      <div className="tab-content py-4">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`tab-pane ${index === activeTab ? "active" : ""}`}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavTab;
